<template>
  <button class="bouton imageBouton boutonPlus" @click="clicked">
    <slot />
    <input id="importBs" ref="import" type="file" @change="change" :multiple="multiple" :accept="accept" />
  </button>
</template>

<script>
export default {
  props: ["multiple", "accept"],
  methods: {
    clicked() {
      this.$refs.import.click();
    },

    change(e) {
      let target = e.target;
      if (target && target.files) {
        let files = target.files;
        this.$emit("change", files);
        this.$refs.import.value = "";
      }
    }
  }
};
</script>

<style scoped>
input {
  visibility: hidden;
  width: 0;
  height: 0;
}
</style>
